module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "killerFeatureNoCode.99673061.png";